import { render } from "./HomeView.vue?vue&type=template&id=cad796f6"
const script = {}
script.render = render

export default script